import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cloud_download",
  "use": "icon-cloud_download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cloud_download\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M19.35 10.04a7.492 7.492 0 00-14-2A6 6 0 006 20h13a4.986 4.986 0 00.35-9.96zM17 13l-5 5-5-5h3V9h4v4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol